import { render, staticRenderFns } from "./DebtWriteOff.vue?vue&type=template&id=1d686678&"
import script from "./DebtWriteOff.vue?vue&type=script&lang=js&"
export * from "./DebtWriteOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DebtWriteOff.vue"
export default component.exports